"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingCancelWindow = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const calendar_1 = require("../../../calendar/calendar");
const helpers_1 = require("../../../utils/helpers");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const right_panel_1 = require("../../../widgets/right_panel");
const booking_show_1 = require("./booking_show");
exports.BookingCancelWindow = {
    booking: {},
    details: {},
    active: false,
    isProcessing: false,
    graciously: false,
    show(booking) {
        exports.BookingCancelWindow.booking = booking;
        exports.BookingCancelWindow.active = true;
        exports.BookingCancelWindow.isProcessing = false;
        exports.BookingCancelWindow.graciously = false;
        this.details = {};
        this.simulate();
        mithril_1.default.redraw();
    },
    simulate() {
        let details = this.booking.details;
        let args = this.graciously ? `gracefully=1` : '';
        if (details) {
            app_1.App.get(`/bookings/${details.id}/cancel_simulate?${args}`).then((data) => {
                this.details = data;
            });
        }
    },
    renderDetails() {
        if (this.details === undefined)
            return undefined;
        if (this.details.cancelation_details === undefined)
            return undefined;
        const cd = this.details.cancelation_details;
        const arr = cd.contracts;
        let percent = Math.round(100 * (cd.total_consumed / this.details.duration));
        return (0, mithril_1.default)("ul", { class: "content" }, (0, mithril_1.default)("li", `Consommation totale: `, (0, helpers_1.strong)((0, helpers_1.minutesToUnit)(cd.total_consumed)), " soit ", (0, helpers_1.strong)(`${percent}%`)), arr.map((c) => {
            return (0, mithril_1.default)("li", `Utilisation du `, right_panel_1.RightPanel.linkTo(`Forfait #${c.id} `, "contracts", c.id, "show"), '(', (0, helpers_1.strong)((0, helpers_1.minutesToUnit)(c.consumed)), ' consommé; ', (0, helpers_1.strong)((0, helpers_1.minutesToUnit)(c.free)), ' quota annulation libre )');
        }));
    },
    renderContent() {
        return (0, mithril_1.default)("div", { class: "content" }, (0, mithril_1.default)("p", `Vous êtes sur le point de supprimer la réservation ${this.details.id}. L'opération est irreversible. Details de l'opération:`), this.renderDetails(), (0, form_for_1.checkbox)("Ne pas appliquer de pénalités ( À titre gracieux )", "graciously", this, { oninput: (e) => {
                this.graciously = e.target.checked;
                this.simulate();
            } }));
    },
    view(_node) {
        if (exports.BookingCancelWindow.active) {
            let disabled = this.isProcessing ? true : undefined;
            return (0, modal_1.modalCard)({
                content: exports.BookingCancelWindow.renderContent(),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, (0, mithril_1.default)("button", {
                    class: `button is-success ${this.isProcessing ? "is-loading" : ""}`,
                    disabled: disabled,
                    onclick: (evt) => {
                        evt.preventDefault();
                        this.isProcessing = true;
                        let args = this.graciously ? `gracefully=1` : '';
                        app_1.App.get(`/bookings/${this.details.id}/cancel?${args}`).then((_data) => {
                            calendar_1.Calendar.refresh();
                            booking_show_1.BookingShow.fetch(this.details.id);
                            exports.BookingCancelWindow.active = false;
                        }).finally(() => {
                            this.isProcessing = false;
                        });
                    }
                }, (0, helpers_1.iconSpan)("fa-check"), (0, mithril_1.default)("span", " Confirmer")), (0, mithril_1.default)("button", {
                    class: "button is-danger",
                    disabled: disabled,
                    onclick: (evt) => {
                        evt.preventDefault();
                        exports.BookingCancelWindow.active = false;
                    }
                }, (0, helpers_1.iconSpan)("fa-times"), (0, mithril_1.default)("span", " Annuler"))),
                isActive: exports.BookingCancelWindow.active,
                onClose: () => { exports.BookingCancelWindow.active = false; },
                title: "Confirmer annulation"
            });
        }
        return undefined;
    }
};
